import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useManagementSettingsUpdate() {
  return useFeatureSettingsUpdate('managementLists');
}
